// Nadrama <https://nadrama.com>
// Copyright Nadrama Pty Ltd
// All rights reserved.

// sameOriginPath validates an app destination and returns its router path.
export function sameOriginPath(destination: string, currentOrigin: string) {
  const origin = new URL(currentOrigin).origin;
  const target = new URL(destination, origin);
  if (target.origin !== origin) {
    throw new Error("SPA navigation requires a same-origin destination.");
  }
  return `${target.pathname}${target.search}${target.hash}`;
}

// externalNavigationURL validates and normalizes an external browser destination.
export function externalNavigationURL(destination: string, currentURL: string) {
  const current = new URL(currentURL);
  const target = new URL(destination, current);
  if (!["http:", "https:"].includes(target.protocol) || target.origin === current.origin) {
    throw new Error("Full-document navigation requires an external HTTP origin.");
  }
  return target.href;
}
